// Generated by CoffeeScript 1.11.1
(function() {
  var ResourceSection, _;

  _ = require('lodash');

  module.exports = ResourceSection = (function() {
    var RESOURCES;

    function ResourceSection() {}

    RESOURCES = [require('./resources/layer_comps')];

    ResourceSection.factory = function(resource) {
      var Section, i, len;
      for (i = 0, len = RESOURCES.length; i < len; i++) {
        Section = RESOURCES[i];
        if (Section.prototype.id !== resource.id) {
          continue;
        }
        return _.tap(new Section(resource), function(s) {
          return s.parse();
        });
      }
      return null;
    };

    return ResourceSection;

  })();

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./lib/psd/resource_section.js
// module id = 84
// module chunks = 0